import React from "react";

// CyboScan mark: hex-shield outline, scanning sweep, and a pulse node — Graphite + Digital Violet identity.
export function LogoMark({ size = 32, className = "", id = "cs" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-g`} x1="8" y1="6" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#B9E8FF" /><stop offset="1" stopColor="#7657FF" />
        </linearGradient>
        <linearGradient id={`${id}-s`} x1="32" y1="14" x2="32" y2="50" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7657FF" stopOpacity="0" /><stop offset="1" stopColor="#7657FF" stopOpacity=".55" />
        </linearGradient>
      </defs>
      <path d="M32 3 L57 16 V34 C57 46 46 56 32 61 C18 56 7 46 7 34 V16 Z" fill="#15151F" stroke={`url(#${id}-g)`} strokeWidth="3" strokeLinejoin="round" />
      <path d="M32 3 L57 16 V34 C57 46 46 56 32 61 C18 56 7 46 7 34 V16 Z" fill={`url(#${id}-s)`} />
      <path d="M44.5 24.5 A15 15 0 1 0 44.5 41" stroke="#B9E8FF" strokeWidth="4" strokeLinecap="round" />
      <path d="M20 40 L27 40 L31 30 L36 44 L40 36 L46 36" stroke="#7657FF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="46" cy="36" r="3.2" fill="#B9E8FF" />
    </svg>
  );
}

export default function Logo({ size = 32, text = true, sub, className = "", light = false, id = "cs" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} id={id} />
      {text && (
        <span className="leading-none">
          <span className="font-display font-extrabold tracking-tight" style={{ fontSize: size * 0.62, color: light ? "#15151F" : "#F5F3FF" }}>Cybo<span style={{ color: "#7657FF" }}>Scan</span></span>
          {sub && <span className="block text-[9px] font-mono uppercase tracking-[0.22em] mt-1" style={{ color: light ? "#52525B" : "#8B8BA7" }}>{sub}</span>}
        </span>
      )}
    </span>
  );
}
